var Cookies = $.extend({/* Cookies */}, BaseComponent, {

	componentSelector: '.page-content-alert-cookies',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).find('.dismiss-alert').find('a').click((function(event) {

			$(event.currentTarget).parents(this.componentSelector).animate({
				height: 0
			}, 450, function() {
				$(event.currentTarget).parents('.page-content-alert-cookies').removeClass('view-on');
				$(event.currentTarget).parents('.page-content-alert-cookies').addClass('view-off');
			});

		}).bind(this));
	}
})